import type { MembershipStatsResponse } from '@/types/member/memberTypes'
import { withEarlyResponse } from '~/utils/earlyResponse'

export type { MembershipStatsResponse }
export const MEMBERSHIP_STATS_KEY = 'membership-stats'
const MEMBERSHIP_STATS_URL = '/api/membership-stats'

export interface MemberStatsOptions {
  lazy?: boolean
}

/**
 * Pool-wide membership counts from `/api/membership-stats`. `membersByTier` there counts
 * the members a distribution would consider, which every payout projection splits across.
 * On the landing page the first read takes over the request the page made as it loaded.
 */
export function useMemberStats(options: MemberStatsOptions = {}) {
  const { lazy = false } = options
  const requestFetch = useRequestFetch()

  const { data, pending, error, status, refresh, clear } = useAsyncData(
    MEMBERSHIP_STATS_KEY,
    (_nuxtApp, { signal }) => withEarlyResponse(MEMBERSHIP_STATS_URL, () =>
      requestFetch<MembershipStatsResponse>(MEMBERSHIP_STATS_URL, { signal })),
    { server: !lazy, lazy, immediate: !lazy },
  )

  return { data, pending, error, status, refresh, clear }
}
